// extracted by mini-css-extract-plugin
export default {"textSearchFieldContainer":"uN39h","heading":"DOqGl"};